import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightLong } from "@fortawesome/free-solid-svg-icons";
import ProductionServices from "../../services/axioServices/apiServices/ProductionServices.js";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import SwalServices from "../../services/swalServices/SwalServices.js";
import moment from "moment";
import { getAuthProps } from "../../utils/AuthenticationLibrary.js";
import { printFunction } from "../../components/print/printTemplate.js";

class BatchCostingReport extends Component {
  constructor(props) {
    super(props);
    this.productionServices = new ProductionServices();
    this.commonServices = new CommonServices();
    this.SwalServices = new SwalServices();
    this.state = {
      companyName: '',
      isGridView: true,
      batchClearedList: [],
      batchClearRecords: [],
      rmFormulaList: [],
      pmFormulaList: [],
      batchCostingRecords: [],
      isLoading: false,
      tableStatus: "",
      filterDetails: {
        productName: "",
        arrangedBy: "",
      },
      productDetails: {
        productName: "",
        size: "",
        RMtotal: "",
        PMtotal: "",
        batchNo: "",
        prodNo: "",
        btSize: "",
        mfgDate: "",
        totalRmPm: "",
        testingCharges: 0.0,
        otherCharges: "",
        totalBatchCost: "",
        yeild: "",
        unitQty: 0,
      },
      filterByList: [
        { filterBy: "Slip No.", value: "prodNo" },
        { filterBy: "Batch No", value: "batchNo" },
        { filterBy: "Batch Size", value: "batchSize" },
      ],
    };
  }

  componentDidMount() {
    this.getAllBatchClearedRecords();
    const company = getAuthProps()
    this.setState({ companyName: company?.companyName })
  }

  getAllBatchClearedRecords = () => {
    this.setState({ tableStatus: "Loading..." })
    let request = this.state.filterDetails;
    this.productionServices
      .getAllBatchClearedRecords(request)
      .then((response) => {
        if (response.statusCode === 200 && response.responseData != null) {
          if (response.responseData.length === 0) {
            this.setState({ tableStatus: "No Record Found" })
          } else {
            this.setState({ tableStatus: "" })
          }
          let res = response.responseData;
          this.setState({ batchClearedList: res }, () => { });
        } else {
          this.setState({ tableStatus: "" })
          this.SwalServices.Error(response.Message);
        }
      });
  };

  closeGridView = () => {
    this.setState({ isGridView: false });
  };

  openGridView = () => {
    this.resetForm();
    this.setState({ isGridView: true, isEditing: false });
  };

  resetForm = () => {
    let Fdetails = this.state.filterDetails;
    Fdetails.productName = "";
    Fdetails.arrangedBy = "";
    let details = this.state.productDetails;
    details.productName = "";
    details.size = "";
    details.RMtotal = "";
    details.PMtotal = "";
    details.batchNo = "";
    details.prodNo = "";
    details.btSize = "";
    details.mfgDate = "";
    details.totalRmPm = "";
    details.testingCharges = "";
    details.otherCharges = "";
    details.yeild = "";
    this.setState({ productDetails: details, filterDetails: Fdetails });
  };

  setFilterParameters = (selected, drpIdentity) => {
    let details = this.state.productDetails;
    details[drpIdentity] = selected.value;
    this.setState({ productDetails: details });
  };

  handleChange = (event, name, section) => {
    let value = event.target.value;
    if (section === "filterDetails") {
      let details = this.state.filterDetails;
      details[name] = value.toUpperCase();
      this.setState({ filterDetails: details }, () => {
        this.getAllBatchClearedRecords()
      });
    } else if (section === "productDetails") {
      let details = this.state.productDetails;
      details[name] = value.toUpperCase();
      if (name === "otherCharges") {
        details.totalBatchCost =
          Number(details.totalRmPm) +
          Number(details.testingCharges) +
          Number(details.otherCharges);
        this.costCalculation();
      }
      this.setState({ productDetails: details });
    }
  };

  handleDropDownChange = (event, name) => {
    const select = event.target.value;
    if (select !== "Select") {
      let details = this.state.filterDetails;
      details[name] = select;
      this.setState({ filterDetails: details });
    }
  };

  getProductDetailsForBatchClearedByProductId = (item) => {
    let details = this.state.productDetails;
    details.productName = item?.productName;
    details.batchNo = item?.batchNo;
    details.btSize = item?.batchSize;
    details.prodNo = item?.productionNo;
    details.mfgDate = moment(item?.mfgDate).format(
      "yyyy-MM-DD"
    );
    this.setState({ productDetails: details }, () => {
      this.productionServices
        .getProductDetailsForBatchClearedByProductId(item.productDetialsId)
        .then((response) => {
          if (response.statusCode === 200 && response.responseData != null) {
            let res = response.responseData;

            let details = this.state.productDetails;
            const yieldValue = res.reduce((acc, record) => {
              return (
                acc +
                (record.quantity + record.retainSample) *
                record.packingItemId.UnitQuantity
              );
            }, 0);

            const yieldPercentage = Number((yieldValue / Number(details.btSize)) * 100).toFixed(2);
            details.yeild = yieldPercentage;

            res.forEach((record) => {
              if (record.retainSample > 0) {
                res.push({
                  id: record.id,
                  date: "RTS",
                  quantity: record.retainSample,
                  packing: record.packing,
                  isRetainSampleRecord: true,
                });
              }
            });

            this.setState({ batchClearRecords: res }, () => {
              this.getBatchCostingReportRMFormulaId(item.productDetialsId);
            });
          } else {
            this.SwalServices.Error(response.Message);
          }
        });
    });
  };

  getBatchCostingReportRMFormulaId = (id) => {
    this.productionServices
      .getBatchCostingReportRMFormulaId(id)
      .then((response) => {
        if (response.statusCode === 200 && response.responseData != null) {
          let array = response.responseData;
          array = array.map((item) => {
            item.totalAmount = (
              Number(item.netQty) * Number(item.grnRate)
            ).toFixed(3);
            return item;
          });
          this.setState({ rmFormulaList: array }, () => {
            let totalRM = this.state.rmFormulaList.reduce(
              (accumulator, item) => {
                return accumulator + Number(item.totalAmount);
              },
              0
            );
            let details = this.state.productDetails;
            details.RMtotal = totalRM.toFixed(2);
            this.setState({ productDetails: details });
            this.getBatchCostingReportPMFormulaById(id);
          });
        } else {
          this.SwalServices.Error(response.Message);
        }
      });
  };

  getBatchCostingReportPMFormulaById = (id) => {
    this.productionServices
      .getBatchCostingReportPMFormulaById(id)
      .then((response) => {
        if (response.statusCode === 200 && response.responseData != null) {
          let array = response.responseData;
          array = array.map((item) => {
            item.totalAmount = (
              Number(item.netQty) * Number(item.grnRate)
            ).toFixed(3);
            return item;
          });
          this.setState({ pmFormulaList: array, isGridView: false }, () => {
            let totalPM = this.state.pmFormulaList.reduce(
              (accumulator, item) => {
                return accumulator + Number(item.totalAmount);
              },
              0
            );
            let details = this.state.productDetails;
            details.PMtotal = totalPM.toFixed(2);
            details.totalRmPm = (
              Number(details.PMtotal) + Number(details.RMtotal)
            ).toFixed(2);

            details.totalBatchCost = (
              Number(details.totalRmPm) +
              Number(details.testingCharges) +
              Number(details.otherCharges)
            ).toFixed(2);

            this.setState({ productDetails: details }, () => {
              this.costCalculation();
            });
          });
        } else {
          this.SwalServices.Error(response.Message);
        }
      });
  };

  costCalculation = () => {
    if (this.state.batchClearRecords.length > 0) {
      let list = this.state.batchClearRecords.filter(
        (item) => item.isRetainSampleRecord !== true
      );
      let value = list.reduce((acc, record) => {
        return (
          acc +
          (record.quantity + record.retainSample) *
          record.packingItemId.UnitQuantity
        );
      }, 0);

      let batchCostingRecords = [];

      list.forEach((record) => {
        let cost =
          (Number(this.state.productDetails.totalBatchCost) / Number(value)) *
          Number(record.packingItemId.UnitQuantity);
        batchCostingRecords.push({
          packing: record.packing,
          cost: cost.toFixed(2),
          jobCharge: record.packingItemId.JobCharge,
          netCharge: (
            Number(cost) + Number(record.packingItemId.JobCharge)
          ).toFixed(2),
        });
      });

      this.setState({ batchCostingRecords: batchCostingRecords });
    }
  };

  render() {
    return (
      <div className="batchCostingReport-page">
        {/* First page  */}
        {this.state.isGridView === true ? (
          <>
            {/* 1. Item Search  */}
            <div className="item-search w-[60%]">
              <div className="item-grp flex gap-2.5 mb-2.5">
                <div className="search-grp w-[60%]">
                  <label>Product Name</label>
                  <input
                    type="text"
                    id="productName"
                    name="productName"
                    autoComplete="off"
                    className="inputFocus w-full"
                    value={this.state.filterDetails.productName}
                    onChange={(event) =>
                      this.handleChange(event, "productName", "filterDetails")
                    }
                  />
                </div>

                {/* <div className="search-grp w-[40%]">
                  <label>Arranged By:</label>
                  <select
                    name="arrangedBy"
                    className="w-full"
                    value={this.state.filterDetails.arrangedBy}
                    onChange={(event) =>
                      this.handleDropDownChange(
                        event,
                        "arrangedBy",
                        "filterDetails"
                      )
                    }
                  >
                    <option>Select</option>
                    {this.state.filterByList.map((x, key) => (
                      <option key={key} value={x.value}>
                        {x.filterBy}
                      </option>
                    ))}
                  </select>
                </div> */}


              </div>
            </div>

            {/* 2. Item tabel  */}
            <div className="itemList-table print:break-after-page print:pt-10 print:mt-10 print:border-t-4 print:border-gray-400 print:pb-5 print:px-5">
              <div className="table-container print:h-auto print:overflow-visible" style={{ height: "calc(100vh - 125px)" }}>
                <table className="itemList">
                  <thead className="print:!relative print:!shadow-none print:bg-transparent">
                    <tr>
                      <td className="w-[10%]">Prod No</td>
                      <td className="w-[25%]">Product Name</td>
                      <td className="w-[14%]">Batch No.</td>
                      <td className="w-[14%]">Mfg. Date</td>
                      <td className="w-[14%]">Batch Size</td>
                      <td className="w-[13%]">Net Qty</td>
                      <td className="w-[10%]" style={{ textAlign: "center" }}>Action</td>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.batchClearedList &&
                      this.state.batchClearedList.length > 0
                      ? this.state.batchClearedList.map((item, key) => (
                        <tr key={key}>
                          <td>{item?.productionNo}</td>
                          <td>{item?.productName}</td>
                          <td>{item?.batchNo}</td>
                          <td>{item?.mfgDate ? moment(item.mfgDate).format("DD MMM yyyy") : ""}</td>
                          <td>{item?.batchSize}</td>
                          <td>{(item?.netQuantity && Number(item?.netQuantity) > 0) ? Number(item?.netQuantity).toFixed(2) : 0}</td>
                          <td style={{ textAlign: "center" }}>
                            <button
                              className="add-btn !w-fit !h-fit !py-[6px] !px-[6px] leading-normal"

                              onClick={() =>
                                this.getProductDetailsForBatchClearedByProductId(
                                  item
                                )
                              }
                            >

                              <FontAwesomeIcon icon={faArrowRightLong} />
                            </button>
                          </td>
                        </tr>
                      ))
                      : this.state.batchClearedList &&
                        this.state.batchClearedList.length === 0
                        && this.state.tableStatus !== "" ? (
                        <tr>
                          <td colSpan={7} style={{ textAlign: "center", fontSize: "16px" }}>
                            {this.state.tableStatus}
                          </td>
                        </tr>
                      ) : this.state.batchClearedList &&
                        this.state.batchClearedList.length === 0
                        && this.state.tableStatus === "" ? null : ""}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        ) : null}

        {/* Second page  */}
        {this.state.isGridView === false ? (
          <>
            <div className="flex gap-3">
              <div className="hidden print-title print:flex print:justify-between print:items-center print:mb-2">
                <h4 className="text-black font-semibold text-[18px]">Batch Costing Report</h4>
                <p className="text-black"><span>Item name:- {this.state.productDetails.productName}</span>, Batch no:- {this.state.productDetails.batchNo}, Batch size:- {this.state.productDetails.btSize}
                  <br /> Production no:- {this.state.productDetails.prodNo}, Mfg. date:- {this.state.productDetails.mfgDate}
                </p>
              </div>
              {/* First section   */}
              <div className="basis-[72%]">
                <div className="item-search no-print">
                  <div className="item-grp flex gap-2.5 mb-2.5">
                    <div className="search-grp w-[42%]">
                      <label>Product Name</label>
                      <input
                        type="text"
                        id="productName"
                        name="productName"
                        className="inputFocus w-full"
                        disabled
                        autoComplete="off"
                        value={this.state.productDetails.productName}
                        onChange={(event) =>
                          this.handleChange(
                            event,
                            "productName",
                            "productDetails"
                          )
                        }
                      />
                    </div>
                    <div className="search-grp w-[14%]">
                      <label>Batch No.</label>
                      <input
                        className="inputFocus"
                        type="text"
                        id="batchNo"
                        name="batchNo"
                        disabled
                        autoComplete="off"
                        value={this.state.productDetails.batchNo}
                        onChange={(event) =>
                          this.handleChange(event, "batchNo", "productDetails")
                        }
                      />
                    </div>
                    <div className="search-grp w-[15%]">
                      <label>Batch Size</label>
                      <input
                        className="inputFocus"
                        type="number"
                        id="btSize"
                        name="btSize"
                        disabled
                        autoComplete="off"
                        value={this.state.productDetails.btSize}
                        onChange={(event) =>
                          this.handleChange(event, "btSize", "productDetails")
                        }
                      />
                    </div>
                    <div className="search-grp w-[15%]">
                      <label>Prod No.</label>
                      <input
                        className="inputFocus"
                        type="text"
                        id="prodNo"
                        name="prodNo"
                        disabled
                        autoComplete="off"
                        value={this.state.productDetails.prodNo}
                        onChange={(event) =>
                          this.handleChange(event, "prodNo", "productDetails")
                        }
                      />
                    </div>
                    <div className="search-grp w-[18%]">
                      <label>Mfg. Date</label>
                      <input
                        className="inputFocus"
                        type="date"
                        id="mfgDate"
                        name="mfgDate"
                        disabled
                        autoComplete="off"
                        value={this.state.productDetails.mfgDate}
                        onChange={(event) =>
                          this.handleChange(event, "mfgDate", "productDetails")
                        }
                      />
                    </div>

                    {/* <div className="search-grp w-[40%]">
                      <label>Size</label>
                      <input  
                      className="inputFocus"
                        type="number"
                        id="size"
                        name="size"
                        className="w-full"
                        disabled
                        value={this.state.productDetails.size}
                        onChange={(event) =>
                          this.handleChange(event, "size", "productDetails")
                        }
                      />
                    </div> */}
                  </div>
                </div>

                {/* Table  */}
                <div className="itemList-table print:break-after-page">
                  <div className="itemList-table-inner ">
                    <div className="table-container h-[44vh] print:h-auto print:overflow-visible">
                      <table className="itemList">
                        <thead className="print:!relative print:!shadow-none print:bg-transparent">
                          <tr>
                            <td className="w-[25%] print-w-25">Material Name</td>
                            <td className="w-[15%] print-w-15">GRN No.</td>
                            <td className=" w-[15%] print-w-15">Quantity</td>
                            <td className="w-[15%] print-w-15">U.O.M</td>
                            <td className=" w-[15%] print-w-15">Rate</td>
                            <td className="w-[15%] print-w-15">Amount</td>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.rmFormulaList &&
                            this.state.rmFormulaList.length > 0
                            ? this.state.rmFormulaList.map((item, key) => (

                              <tr key={key}>
                                <td>{item?.rmName}</td>
                                <td>{item?.grnNo}</td>
                                <td>{item?.netQty}</td>
                                <td>{item?.rmUOM ? item?.rmUOM : item?.uom}</td>
                                <td>{item?.grnRate}</td>
                                <td>{item?.totalAmount}</td>
                              </tr>

                            ))
                            : null}
                          <tr className="last-row hidden">
                            <td className="end" colSpan={5}>R. M. Total</td>
                            <td>{this.state.productDetails.RMtotal}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div className="search-grp flex justify-end gap-2.5 mt-3.5 mb-3.5 no-print">
                      <div className="flex justify-end items-center text-[14px] font-medium text-[#585858]">
                        R.M. Total
                      </div>
                      <input
                        className="inputFocus w-[20%]"
                        type="number"
                        id="RMtotal"
                        name="RMtotal"
                        autoComplete="off"
                        disabled
                        value={this.state.productDetails.RMtotal}
                        onChange={(event) =>
                          this.handleChange(event, "RMtotal", "productDetails")
                        }
                      />
                    </div>
                  </div>
                  <div className="itemaList-table-inner ">
                    <div className="table-container h-[22vh] print:h-auto print:overflow-visible">
                      <table className="itemList">
                        <thead className="print:!relative print:!shadow-none print:bg-transparent">
                          <tr>
                            <td className="w-[25%] print:text-slate-950 print:border print:border-[#e5e7eb]">Material Name</td>
                            <td className="w-[15%] print:text-slate-950 print:border print:border-[#e5e7eb]">GRN No.</td>
                            <td className="w-[15%] print:text-slate-950 print:border print:border-[#e5e7eb]">Quantity</td>
                            <td className="w-[15%] print:text-slate-950 print:border print:border-[#e5e7eb]">U.O.M</td>
                            <td className="w-[15%] print:text-slate-950 print:border print:border-[#e5e7eb]">Rate</td>
                            <td className="w-[15%] print:text-slate-950 print:border print:border-[#e5e7eb]">Amount</td>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.pmFormulaList &&
                            this.state.pmFormulaList.length > 0
                            ? this.state.pmFormulaList.map((item, key) => (

                              <tr key={key}>
                                <td>{item.pmName}</td>
                                <td>{item.grnNo}</td>
                                <td>{item.netQty}</td>
                                <td>{item.rmUOM ? item.rmUOM : item.uom}</td>
                                <td>{item.grnRate}</td>
                                <td>{item.totalAmount}</td>
                              </tr>

                            ))
                            : null}
                          <tr className="last-row hidden">
                            <td className="end" colSpan={5}>P. M. Total</td>
                            <td>{this.state.productDetails.PMtotal}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="search-grp flex justify-end gap-2.5 mt-3.5 no-print">
                      <div className="flex justify-end items-center text-[14px] font-medium text-[#585858]">
                        P.M. Total
                      </div>
                      <input
                        className="inputFocus w-[20%]"
                        type="number"
                        id="PMtotal"
                        name="PMtotal"
                        disabled
                        autoComplete="off"
                        value={this.state.productDetails.PMtotal}
                        onChange={(event) =>
                          this.handleChange(event, "PMtotal", "productDetails")
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              <span className='mt-[3px] border-l-2'></span>
              {/* Second section  */}
              <div className="total-table hidden">
                <table>
                  <tbody>
                    <tr>
                      <td className="print-w-70%">Total RM + PM Amount</td>
                      <td className="print-w-30%">{this.state.productDetails.totalRmPm}</td>
                    </tr>
                    <tr>
                      <td className="print-w-70%">FP - Testing Charges</td>
                      <td className="print-w-30%">{this.state.productDetails.testingCharges}</td>
                    </tr>
                    <tr>
                      <td className="print-w-70%">Other Charges</td>
                      <td className="print-w-30%">{this.state.productDetails.otherCharges}</td>
                    </tr>
                    <tr>
                      <td className="print-w-70%">Total Batch Cost</td>
                      <td className="print-w-30%">{this.state.productDetails.totalBatchCost}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className=" item-sections min-w-[360px] max-w-[435px] mb-auto w-[28%]  flex flex-col no-print">
                <div className="item-sections">
                  <div className="search-grp flex gap-2.5 ">
                    <div className="w-[50%] flex items-center text-[14px] font-medium text-[#585858]">
                      Total RM + PM Amount
                    </div>
                    <input
                      className="inputFocus w-[50%]"
                      type="number"
                      id="totalRmPm"
                      name="totalRmPm"
                      disabled
                      autoComplete="off"
                      value={this.state.productDetails.totalRmPm}
                      onChange={(event) =>
                        this.handleChange(event, "totalRmPm", "productDetails")
                      }
                    />
                  </div>

                  <div className="search-grp flex gap-2.5 mt-2.5">
                    <div className="w-[50%] flex items-center text-[14px] font-medium text-[#585858]">
                      FP - Testing Charges
                    </div>
                    <input
                      className="inputFocus w-[50%]"
                      type="number"
                      id="testingCharges"
                      name="testingCharges"
                      disabled
                      autoComplete="off"
                      value={this.state.productDetails.testingCharges}
                      onChange={(event) =>
                        this.handleChange(
                          event,
                          "testingCharges",
                          "productDetails"
                        )
                      }
                    />
                  </div>

                  <div className="search-grp flex gap-2.5 mt-2.5">
                    <div className="w-[50%] flex items-center text-[14px] font-medium text-[#585858]">
                      Other Charges
                    </div>
                    <input
                      className="inputFocus w-[50%]"
                      type="number"
                      id="otherCharges"
                      name="otherCharges"
                      autoComplete="off"
                      value={this.state.productDetails.otherCharges}
                      onChange={(event) =>
                        this.handleChange(
                          event,
                          "otherCharges",
                          "productDetails"
                        )
                      }
                    />
                  </div>

                  <div className="search-grp flex gap-2.5 mt-2.5 ">
                    <div className="w-[50%] flex items-center text-[14px] font-medium text-[#585858]">
                      Total Batch Cost
                    </div>
                    <input
                      className="inputFocus w-[50%]"
                      type="number"
                      id="totalBatchCost"
                      name="totalBatchCost"
                      disabled
                      autoComplete="off"
                      value={this.state.productDetails.totalBatchCost}
                      onChange={(event) =>
                        this.handleChange(
                          event,
                          "totalBatchCost",
                          "productDetails"
                        )
                      }
                    />
                  </div>
                  <div className=" text-[14px] mt-4 font-medium text-[#585858]">Batch Clearing Details</div>
                  <div className="itemList-table">
                    <div className="table-container h-[24vh] print:h-auto print:overflow-visible" >

                      <table className="itemList">
                        <thead className="print:!relative print:!shadow-none print:bg-transparent">
                          <tr>
                            <td className="print:text-slate-950 print:border print:border-[#e5e7eb]">Date</td>
                            <td className="print:text-slate-950 print:border print:border-[#e5e7eb]">Pack</td>
                            <td className="print:text-slate-950 print:border print:border-[#e5e7eb]">Qty.</td>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.batchClearRecords &&
                            this.state.batchClearRecords.length > 0
                            ? this.state.batchClearRecords.map((item, key) => (
                              <tr key={key}>
                                <td>
                                  {item.isRetainSampleRecord
                                    ? item.date
                                    : moment(
                                      item.productDetialsId.despDate
                                    ).format("DD MMM yyyy")}
                                </td>
                                <td>{item.packing}</td>
                                <td>{item.quantity}</td>
                              </tr>
                            ))
                            : null}
                        </tbody>
                      </table>
                    </div>
                    <div className="search-grp flex justify-end gap-2.5 mt-[12px] mb-[12px]">
                      <div className="flex items-center text-[14px] font-medium text-[#585858]">
                        Yeild %
                      </div>
                      <input
                        className="inputFocus w-[50%]"
                        type="number"
                        id="yeild"
                        name="yeild"
                        disabled
                        autoComplete="off"
                        value={this.state.productDetails.yeild}
                        onChange={(event) =>
                          this.handleChange(event, "yeild", "productDetails")
                        }
                      />
                    </div>
                  </div>

                  <div className="itemList-table">
                    <div className="table-container h-[22vh] print:h-auto print:overflow-visible">
                      <table className="itemList">
                        <thead className="print:!relative print:!shadow-none print:bg-transparent">
                          <tr>
                            <td className="print:text-slate-950 print:border print:border-[#e5e7eb]">Packing</td>
                            <td className="print:text-slate-950 print:border print:border-[#e5e7eb]">Cost</td>
                            <td className="print:text-slate-950 print:border print:border-[#e5e7eb]">Job.Chg</td>
                            <td className="print:text-slate-950 print:border print:border-[#e5e7eb]">Net</td>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.batchCostingRecords &&
                            this.state.batchCostingRecords.length > 0
                            ? this.state.batchCostingRecords.map(
                              (item, key) => (
                                <tr key={key}>
                                  <td>{item.packing}</td>
                                  <td>{item.cost}</td>
                                  <td>{item.jobCharge}</td>
                                  <td>{item.netCharge}</td>
                                </tr>
                              )
                            )
                            : null}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="flex gap-2.5 mt-3.5 print:hidden">
                    <button
                      className="print-btn"
                      onClick={() => printFunction()}
                    >
                      Print
                    </button>
                    <button
                      className="cancel-btn !ml-0"
                      onClick={() => this.openGridView()}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : null
        }

        {/*----- Print layout -----*/}
        <div className='table-print mt-5 hidden' id="printableArea">
          {/* Header */}
          <div className="print-header">
            <table className="hdr-table">
              <tbody>
                <tr>
                  <td>
                    <div className="co-name">{this.state.companyName}</div>
                    <div className="rpt-sub">Batch Costing Report</div>
                  </td>
                  <td>
                    <div className="hdr-meta">
                      Item Name: <strong>{this.state.productDetails.productName}</strong><br />
                      Batch No: <strong>{this.state.productDetails.batchNo}</strong>, Batch Size: <strong>{this.state.productDetails.btSize}</strong><br />
                      Prod No: <strong>{this.state.productDetails.prodNo}</strong>, Mfg. Date: <strong>{this.state.productDetails.mfgDate}</strong>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="rule-thick" />
            <div className="rule-thin" />
          </div>


          <div className="print-content">

            {/* <div className="info-row">
                                                      <div>
                                                        <span className="info-label">Item Name:</span>
                                                        <p className="info-value">Paracetamol</p>
                                                      </div>
                                                    </div> */}

            {/* Table */}
            <table className="data-tbl">
              <colgroup>
                <col style={{ width: "25%" }} />
                <col style={{ width: "15%" }} />
                <col style={{ width: "15%" }} />
                <col style={{ width: "15%" }} />
                <col style={{ width: "15%" }} />
                <col style={{ width: "15%" }} />
              </colgroup>

              <thead>
                <tr>
                  <th style={{ textAlign: 'left' }}>
                    Material Name
                  </th>
                  <th style={{ textAlign: 'left' }}>
                    GRN No
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Quantity
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    UOM
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Rate
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Amount
                  </th>
                </tr>
              </thead>

              <tbody>
                {this.state.rmFormulaList &&
                  this.state.rmFormulaList.length > 0
                  ? this.state.rmFormulaList.map((item, key) => (
                    <tr key={key}>
                      <td style={{ textAlign: 'left' }}>
                        {item?.rmName}
                      </td>
                      <td style={{ textAlign: 'left' }}>
                        {item?.grnNo}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {item?.netQty}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {item?.rmUOM ? item?.rmUOM : item?.uom}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {item?.grnRate}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {item?.totalAmount}
                      </td>
                    </tr>
                  )) : (
                    <tr>
                      <td colSpan="6" style={{ textAlign: 'center' }}>
                        No Data Found
                      </td>
                    </tr>
                  )}
              </tbody>
              <tfoot>
                <tr style={{ backgroundColor: '#f5f5f5' }}>
                  <td colSpan="5" style={{ textAlign: 'left', fontWeight: 'bold' }}>
                    R.M. Total
                  </td>
                  <td style={{ textAlign: 'center', fontWeight: 'bold' }}>
                    {this.state.productDetails.RMtotal}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>

          <div className="print-content">

            {/* <div className="info-row">
                                                      <div>
                                                        <span className="info-label">Item Name:</span>
                                                        <p className="info-value">Paracetamol</p>
                                                      </div>
                                                    </div> */}

            {/* Table */}
            <table className="data-tbl">
              <colgroup>
                <col style={{ width: "25%" }} />
                <col style={{ width: "15%" }} />
                <col style={{ width: "15%" }} />
                <col style={{ width: "15%" }} />
                <col style={{ width: "15%" }} />
                <col style={{ width: "15%" }} />
              </colgroup>

              <thead>
                <tr>
                  <th style={{ textAlign: 'left' }}>
                    Material Name
                  </th>
                  <th style={{ textAlign: 'left' }}>
                    GRN No
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Quantity
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    UOM
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Rate
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Amount
                  </th>
                </tr>
              </thead>

              <tbody>
                {this.state.pmFormulaList &&
                  this.state.pmFormulaList.length > 0
                  ? this.state.pmFormulaList.map((item, key) => (
                    <tr key={key}>
                      <td style={{ textAlign: 'left' }}>
                        {item.pmName}
                      </td>
                      <td style={{ textAlign: 'left' }}>
                        {item.grnNo}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {item.netQty}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {item.rmUOM ? item.rmUOM : item.uom}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {item.grnRate}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {item.totalAmount}
                      </td>
                    </tr>
                  )) : (
                    <tr>
                      <td colSpan="6" style={{ textAlign: 'center' }}>
                        No Data Found
                      </td>
                    </tr>
                  )}
              </tbody>
              <tfoot>
                <tr style={{ backgroundColor: '#f5f5f5' }}>
                  <td colSpan="5" style={{ textAlign: 'left', fontWeight: 'bold' }}>
                    P.M. Total
                  </td>
                  <td style={{ textAlign: 'center', fontWeight: 'bold' }}>
                    {this.state.productDetails.PMtotal}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>

          <div class="print-content total-section">
            <table class="total-tbl">
              <tbody>
                <tr>
                  <td class="total-label">Total RM+PM Amount</td>
                  <td class="total-value">{this.state.productDetails.totalRmPm}</td>
                </tr>
                <tr>
                  <td class="total-label">FP - Testing Charges</td>
                  <td class="total-value">{this.state.productDetails.testingCharges}</td>
                </tr>
                <tr>
                  <td class="total-label">Other Charges</td>
                  <td class="total-value">{this.state.productDetails.otherCharges}</td>
                </tr>
                <tr class="grand-total-row">
                  <td class="total-label">Total Batch Cost</td>
                  <td class="total-value">{this.state.productDetails.totalBatchCost}</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Footer */}
          <div className="print-footer">
            <div className="rule-foot">
              <table className="foot-tbl">
                <tbody>
                  <tr>
                    <td>* System generated report. No signature required.</td>
                    <td style={{ textAlign: "right" }}>
                      Printed: {new Date().toLocaleDateString("en-GB")} {new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>
    );
  }
}

export default BatchCostingReport;
